module["exports"] = [
    "worldlink.com.np",
    "gmail.com",
    "yahoo.com",
    "hotmail.com"
];
